import { H4 } from '@/components/sv/typographies'
import { CardAction, CardDescription, CardHeader } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export const ToggleWebhookFallback = () => (
  <>
    <CardHeader className="py-6 pb-0">
      <H4>
        <Skeleton className="h-6 w-38 mb-2" />
      </H4>
      <CardDescription>
        <Skeleton className="h-4 w-205" />
      </CardDescription>
      <CardAction>
        <Skeleton className="h-9 w-35" />
      </CardAction>
    </CardHeader>
  </>
)
